import { enableBodyScroll, disableBodyScroll } from 'body-scroll-lock';

document.addEventListener('DOMContentLoaded', () => {
	const toggleButtons =
		document.querySelectorAll<HTMLElement>('[data-toggle-nav]');

	const headerCover = document.querySelector<HTMLElement>(
		'[data-header-cover]',
	);

	toggleButtons.forEach((toggleButton) => {
		const elementSelector = toggleButton.getAttribute('data-toggle-nav');
		if (!elementSelector) return;

		const element = document.querySelector<HTMLElement>(elementSelector);
		if (!element) return;

		const open = () => {
			toggleButton.setAttribute('aria-expanded', 'true');
			toggleButton.classList.add('header__toggle-button--open');
			element.classList.add('header__foldout--open');
			if (headerCover) {
				headerCover.style.display = 'block';
			}
			disableBodyScroll(element);
		};

		const close = () => {
			toggleButton.setAttribute('aria-expanded', 'false');
			toggleButton.classList.remove('header__toggle-button--open');
			element.classList.remove('header__foldout--open');
			if (headerCover) {
				headerCover.style.display = 'none';
			}
			enableBodyScroll(element);
		};

		toggleButton.addEventListener('click', () => {
			if (toggleButton.getAttribute('aria-expanded') == 'false') {
				open();
			} else {
				close();
			}
		});

		document.addEventListener('click', (event: MouseEvent) => {
			if (
				toggleButton.getAttribute('aria-expanded') == 'true' &&
				toggleButton !== event.target &&
				event.target instanceof HTMLElement &&
				!element.contains(event.target)
			) {
				close();
			}
		});
	});
});
